import React from "react";
import { FaTv } from "react-icons/fa6";
import { FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import logo from "../../images/logo.jpg";


import { Link } from "react-router-dom";

const Sidebar = () => {
  const navigate = useNavigate();

  const openModal = () => {
    navigate("/profile?openModal=true");
  };

  return (
    <div className="bg-white p-3">
      {/* <Link to={"/"} className="navbar-brand">
        <img src={logo} width={180} className="object-fit-contain" alt="" />
      </Link> */}
      <Link
        to={"/user-dashboard"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 rounded-1 px-4 bg-light"
      >
        <FaTv className="text_maincolor" />
        <p className="mb-0 fs-14">Dashboard</p>
      </Link>{" "}
      <p
        onClick={openModal}
        className=" cursor-pointer d-flex mb-0 align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 px-4 "
      >
        <FaUser className="text_maincolor" />
        <p className="mb-0 fs-14">My Profile</p>
      </p>
      <Link
        to={"/realestate-order"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 px-4 "
      >
        <FaTv className="text_maincolor" />
        <p className="mb-0 fs-14">Real Estate Order</p>
      </Link>{" "}
      <Link
        to={"/colorcorrection-order"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 px-4 "
      >
        <FaTv className="text_maincolor" />
        <p className="mb-0 fs-14">Color Correction </p>
      </Link>{" "}
      <Link
        to={"/culling-order"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 px-4 "
      >
        <FaTv className="text_maincolor" />
        <p className="mb-0 fs-14">Culling </p>
      </Link>{" "}
      <Link
        to={"/retouching-order"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 px-4 "
      >
        <FaTv className="text_maincolor" />
        <p className="mb-0 fs-14">Retouching Order</p>
      </Link>{" "}
      <Link
        to={"/videoediting-order"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 px-4 "
      >
        <FaTv className="text_maincolor" />
        <p className="mb-0 fs-14">Video Editing Order</p>
      </Link>{" "}
      <Link
        to={"/albumdesign-order"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 px-4 "
      >
        <FaTv className="text_maincolor" />
        <p className="mb-0 fs-14">Album Editing Order</p>
      </Link>{" "}
    </div>
  );
};

export default Sidebar;
